
import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const Loader = ({ message = 'Loading...', size = 40 }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="200px"
      gap={2}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" color="textSecondary">
          {message}
        </Typography>
      )}
    </Box>
  )
}

export const InlineLoader = ({ size = 20 }) => {
  return (
    <Box display="inline-flex" alignItems="center">
      <CircularProgress size={size} />
    </Box>
  )
}

export const PageLoader = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
    </Box>
  )
}

export default Loader